import { StorageInterface } from '@packages/shared/core/user/services/storage';
import { Meta, MetaService } from './interfaces/Meta';

export class MetaClientService implements MetaService {
  public meta: Meta = { href: '' };
  private readonly keyPrefix = 'meta_data';

  constructor(private readonly sessionStorage: StorageInterface) {
    this.init();
  }

  public getMeta(): Meta {
    return this.meta;
  }

  private init() {
    const existingMeta = this.sessionStorage.get(this.keyPrefix);

    if (!existingMeta) {
      const initialHref: string = window.location.href;
      this.sessionStorage.set(this.keyPrefix, { href: initialHref });
      this.meta = { href: initialHref };

      return;
    } else {
      this.meta = existingMeta as Meta;
    }
  }
}
